import { ComponentType, lazy, Suspense } from "react";

import { SuspenseLoadingIndicator } from "@/components/ui/loading-indicator";

export function lazyPage(
  factory: () => Promise<{ default: ComponentType<any> }>
) {
  const LazyComponent = lazy(factory);

  const Page = () => (
    <Suspense
      fallback={<SuspenseLoadingIndicator style={{ minHeight: "50vh" }} />}
    >
      <LazyComponent />
    </Suspense>
  );

  return Page;
}
